module.exports = "https://deal-img.imgix.net/consumer/modern/mykonos.1f598386.jpg";